const FamilyIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'>
			<path
				d='M6.66663 12.6667C6.66663 12.6667 3.23796 14.0001 2.66663 18.6667L6.66663 12.6667ZM25.3333 12.6667C25.3333 12.6667 28.762 14.0001 29.3333 18.6667L25.3333 12.6667ZM12 12.6667C12 12.6667 15.2 13.4447 16 17.3334L12 12.6667ZM20 12.6667C20 12.6667 16.8 13.4447 16 17.3334L20 12.6667ZM13.3333 22.6667C13.3333 22.6667 10.5333 23.1667 9.33329 26.6667L13.3333 22.6667ZM18.6666 22.6667C18.6666 22.6667 21.4666 23.1667 22.6666 26.6667L18.6666 22.6667Z'
				fill='#BF8AFC'
			/>
			<path
				d='M6.66663 12.6667C6.66663 12.6667 3.23796 14.0001 2.66663 18.6667M25.3333 12.6667C25.3333 12.6667 28.762 14.0001 29.3333 18.6667M12 12.6667C12 12.6667 15.2 13.4447 16 17.3334C16.8 13.4447 20 12.6667 20 12.6667M13.3333 22.6667C13.3333 22.6667 10.5333 23.1667 9.33329 26.6667M18.6666 22.6667C18.6666 22.6667 21.4666 23.1667 22.6666 26.6667'
				stroke='#BF8AFC'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<path
				d='M16 24C17.8409 24 19.3333 22.5077 19.3333 20.6667C19.3333 18.8258 17.8409 17.3334 16 17.3334C14.159 17.3334 12.6666 18.8258 12.6666 20.6667C12.6666 22.5077 14.159 24 16 24Z'
				fill='#BF8AFC'
				stroke='#BF8AFC'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M22.6666 13.3334C24.8758 13.3334 26.6666 11.5425 26.6666 9.33337C26.6666 7.12424 24.8758 5.33337 22.6666 5.33337C20.4575 5.33337 18.6666 7.12424 18.6666 9.33337C18.6666 11.5425 20.4575 13.3334 22.6666 13.3334Z'
				fill='#BF8AFC'
				stroke='#BF8AFC'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.33325 13.3334C11.5424 13.3334 13.3333 11.5425 13.3333 9.33337C13.3333 7.12424 11.5424 5.33337 9.33325 5.33337C7.12411 5.33337 5.33325 7.12424 5.33325 9.33337C5.33325 11.5425 7.12411 13.3334 9.33325 13.3334Z'
				fill='#BF8AFC'
				stroke='#BF8AFC'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default FamilyIcon;
